<mat-dialog-content>
  <div>
    @if (hasError) {
      <div class="alert alert-danger m-3">{{error}}</div>
    }
    @if (!mediaDevicesSupported) {
      <div class="not-supported px-6 py-6">
        <p>Unfortunately this device does not support accessing the microphone, or does not have a hardware microphone, and cannot be used for dictation.</p>
      </div>
    }
    @if (permissionPending && mediaDevicesSupported) {
      <div class="px-6 py-6">
        <h3>Allow Microphone</h3>
        <span>To record and transcribe audio, click "Allow" above to give Xmedical access to your computer's microphone.</span>
      </div>
    }
    @if (permissionDenied && mediaDevicesSupported) {
      <div class="px-6 py-6">
        <h3>Allow Microphone</h3>
        <span>To record and transcribe audio, Xmedical needs access to your microphone. </span>
        @if (platform.BLINK) {
          <span>Click <i class="error-icon chrome-mic-error-icon"></i> in the URL bar and choose "Always allow xmedical.app to access your microphone. "</span>
        }
        @if (platform.WEBKIT) {
          <span>Click <i class="error-icon chrome-mic-error-icon"></i> in the URL bar and choose "Always allow xmedical.app to access your microphone. "</span>
        }
        @if (platform.FIREFOX) {
          <span>Click <i class="error-icon firefox-mic-error-icon"></i> in the URL bar and choose "Always allow xmedical.app to access your microphone. "</span>
        }
        @if (platform.EDGE) {
          <span>Click <i class="error-icon edge-mic-error-icon"></i> in the URL bar and choose "Always allow xmedical.app to access your microphone. "</span>
        }
        @if (platform.SAFARI) {
          <span>Open your browser's Preferences - Websites and change microphone setting for xmedical.app to "Allow". </span>
        }
        <span>You may need to reload the page for this to take effect</span>
        <button mat-button color="primary" class="mt-3" (click)="reload()">Reload</button>
      </div>
    }
    @if (mediaDevicesSupported && permissionGranted) {
      <div>
        <div class="">
          <app-record-interface (textChanged)="onTextChanged($event)"></app-record-interface>
        </div>
        <div class="mt-3">
          <mat-form-field appearance="fill" color="primary" class="w-100" floatLabel="always">
            <mat-label>Transcribed Audio</mat-label>
            <textarea matInput rows="15" [(ngModel)]="transcribedText"></textarea>
          </mat-form-field>
        </div>
        <div class="d-flex flex-row justify-content-end mt-3">
          <button mat-button (click)="dismiss()">Cancel</button>
          <button mat-flat-button color="primary" (click)="insertTranscription()">Insert Transcription</button>
        </div>
      </div>
    }
  </div>
</mat-dialog-content>
